import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';

import { DRAWER_IDS } from '../../../../../ahm-constants/ui';
import ContactOption from '../../contact-option';
import DrawerActions from '../../../../../actions/drawer';

const GetACallBack = (): JSX.Element => {
  const dispatch = useDispatch();
  const openGetACallBackDrawer = useCallback(() => {
    DrawerActions.openDrawer(DRAWER_IDS.GET_A_CALL_BACK)(dispatch);
  }, [dispatch]);

  return (
    <ContactOption
      buttonText="Call me back"
      buttonOnClick={openGetACallBackDrawer}
      subText={['Fill in the form and one of our helpful humans will call you back as soon as possible.']}
      title="Get a callback"
    />
  );
};

export default GetACallBack;
